import script from "./InitialCallScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialCallScreen.vue?vue&type=script&setup=true&lang=ts"

import "./InitialCallScreen.vue?vue&type=style&index=0&id=25160a18&lang=scss"

const __exports__ = script;

export default __exports__